import { Outlet } from 'react-router-dom';
import { Nav } from './Nav';
import { Tabs } from './Tabs';

export const HomePageUser = () => {
  return (
    <>
      <Nav />
      <section className='page-hero'>
        <h1>Welcome Back</h1>
        <p>Keep building your profile and connect with the right people.</p>
      </section>
      <Tabs />
      <Outlet />
    </>
  );
};
